<template>
    <CogDiff
             :from-value="field.fromvalue"
             :to-value="field.tovalue"
             :from-label="$ta(field.content_textassetid)"
             :to-label="$ta(field.content_upper_textassetid)"
             :value="singleValue"
             @input="emitSingleValue($event)"
    ></CogDiff>
</template>

<script>
  import CogDiff from "./components/CogDiff";
  import responseMixin from "./responseMixin";
  export default {
    name: "CogDiffResponse",
    mixins: [responseMixin],
    components:{
      CogDiff
    },
    computed: {
      items(){
        return (this.field.options || []).map((opt)=>{
          opt['text']=this.$ta(opt.content_textassetid);
          return opt;
        });
      },
      field(){
        return this.journeyanswers[0].field;
      }
    }
  }
</script>

<style scoped>

</style>